exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  LOADSCREEN  */\n.bg_load[data-v-6428c8d2] {\n\t\n\tposition: fixed;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #00000082;\n\tz-index: 100;\n}\n.imgLoad[data-v-6428c8d2]{\n\tposition: absolute;\n\ttop: 48.5%;\n\tmargin-left: 48.5vw;\n\twidth: 3vw;\n\tbackground: transparent;\n}\n@media (min-width: 767px) and (max-width: 1140px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 47.5%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 5vw;\n}\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 45%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 10vw;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6428c8d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lib/loading.vue
// module id = K4Pf
// module chunks = 1